<template>
    <div class="m-0 p-0">
        <div class="row">
            <div class="col-lg-6">
                <div class="contentimage-responsive" style="
                    display: block;
                    position: relative;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    min-height: 148px;"
                    :style="'background-image: url(' + image + ');'">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7">
                      <div class="px-4">
                        <h5>RASTREO DE PAQUETES</h5>
                        <p class="mb-0"><b>Estamos a sus ordenes para cualquier consulta</b></p>
                        <p class="mb-3">7a. avenida 12-11, zona 1, Palacio de Correos, Ala Sur, Guatemala, C.A.</p>
                        <p class="mb-0"><b>PBX:</b> (502) 2318-7700- 2232-6101</p>
                        <p class="mb-0"><b>Código Postal:</b> 01010</p>
                        <p class="mb-0"><b>Horario de atención administrativo:</b></p>
                        <p>De lunes a viernes de 09:00 a 17:00 horas</p>
                      </div>
                    </div>
                    <div class="col-lg-4 position-relative d-none d-lg-block" style="height: 400px;">
                        <img :src="decotriangles" width="125px" class="position-absolute" style="margin: 0; left: 0px; top: 0px;">
                        <img :src="decobars" width="200px" class="position-absolute" style="margin: 0; right: -40px; bottom: 0px;">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import decobars from '@/assets/icons/deco_bars.svg'
import decotriangles from '@/assets/icons/deco_triangles.svg'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      decobars,
      decotriangles
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/clients/components/Header.vue